import log from 'loglevel';
import { ApiService } from './ApiService';
import { useDeviceParams } from '@/composables/device.config';
import { ErrorResponse } from '@/interfaces/ErrorResponse';
import { NoTokenStrategy } from '../strategies/NoTokenStrategy';
import { IVerifyEmailResponse } from '@/interfaces/Auth/IVerifyEmailResponse';
import { IResetPasswordResponse } from '@/interfaces/ForgotPassword/IResetPasswordResponse';
import { IForgotPasswordEmailRequestResponse } from '@/interfaces/ForgotPassword/IForgotPasswordEmailRequestResponse';




class ForgotPasswordServiceClass extends ApiService {



    private VERIFY_EMAIL_ENDPOINT = '/verify_email';
    private RESET_PASSWORD_ENDPOINT = '/reset_password';
    private FORGOT_PASSWORD_ENDPOINT = '/forgot_password';

    private deviceParams = useDeviceParams();



    constructor() {
        super(NoTokenStrategy);
    }




    async emailRequest(email: string): Promise<IForgotPasswordEmailRequestResponse> {
        const data = new FormData();
        data.append('email', email);
        data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));
        data.append('fromBrowser', 'true');

        try {
            const response: IForgotPasswordEmailRequestResponse = await this.post(this.FORGOT_PASSWORD_ENDPOINT, data);

            return response;
        } catch (error: ErrorResponse | any) {
            log.error('Failed to send forgot password email request:', error);

            throw error.response.data.error;
        }
    }





    async resetPassword(verificationCode: string, newPassword: string): Promise<IResetPasswordResponse> {
        const data = new FormData();
        data.append('verification_code', verificationCode);
        data.append('password', newPassword);
        data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));
        data.append('fromBrowser', 'true');

        try {
            const response: IResetPasswordResponse = await this.post(this.RESET_PASSWORD_ENDPOINT, data);
            return response;
        } catch (error) {
            log.error('Failed to reset password:', error);
            throw error;
        }
    }




    async verifyVerificationCode(verificationCode: string): Promise<boolean> {
        try {
            const data = new FormData();
            data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));
            data.append('fromBrowser', 'true');
            const response: IVerifyEmailResponse = await this.post(`${this.VERIFY_EMAIL_ENDPOINT}/${verificationCode}`, data);
            return response.success;
        } catch (error: ErrorResponse | any) {
            log.error('Failed to send forgot password email request:', error);
            throw error.response.data.error;
        }
    }


}

const ForgotPasswordService = new ForgotPasswordServiceClass();
export { ForgotPasswordService };